import { MapPin, ExternalLink } from "lucide-react";
import { useT } from "@/lib/i18n";
import { MAPS_EMBED, MAPS_LINK } from "@/lib/data";

export const Location = ({ lang }) => {
  const t = useT(lang);

  return (
    <section
      id="location"
      data-testid="location-section"
      className="relative py-24 sm:py-32 bg-paper"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#8a6a44] mb-4">
            {t.location.address}
          </div>
          <h2
            data-testid="location-heading"
            className="font-serif-display text-4xl sm:text-5xl text-[#4a3520] leading-[1.05] mb-5"
          >
            {t.location.heading}
          </h2>
          <p className="text-[#5a4530] text-base sm:text-lg leading-relaxed mb-6 max-w-lg">
            {t.location.sub}
          </p>
          <a
            data-testid="location-maps-link"
            href={MAPS_LINK}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 bg-[#8a6a3f] hover:bg-[#7a5d38] text-[#f7f1e6] rounded-full px-6 h-12 text-sm transition"
          >
            <MapPin className="w-4 h-4" />
            {t.location.drive}
            <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>

        <div className="relative rounded-2xl overflow-hidden border border-[#a17a4c]/30 shadow-[0_12px_40px_-20px_rgba(43,29,18,0.4)] aspect-[4/3]">
          <iframe
            data-testid="location-map-iframe"
            src={MAPS_EMBED}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Skyline Retreat location"
          />
        </div>
      </div>
    </section>
  );
};
